import { Spin } from 'antd';

import { AnimationCanvas } from '@suntex.core/animation';

import { createPlayerBadge } from '../display/renderPlayerBadge';

import { playerBadgeComposition } from './playerBadgeComposition';

export function PlayerAvatar({
  params,
  flatten,
}: {
  params?: {
    stickers: number;
    badgeIcon: number;
    badgeBackground: number;
  };
  flatten?: boolean;
}) {
  const width = 190;
  const height = 200;

  return !params ? (
    <div
      style={{
        width,
        height,
      }}
    >
      <Spin />
    </div>
  ) : (
    <AnimationCanvas
      {...{
        ...playerBadgeComposition,
        width,
        height,
        deps: [
          params.stickers,
          params.badgeIcon,
          params.badgeBackground,
          flatten,
        ],
        onReady: ({ stage, lib }) => {
          stage.addChild(
            createPlayerBadge(lib, {
              stickers: params.stickers,
              icon: params.badgeIcon,
              background: params.badgeBackground,
              flatten,
            }),
          );
        },
      }}
    />
  );
}
